module.exports = __webpack_public_path__ + "img/auth-bg-2.3f2bb773.svg";